import gql from 'graphql-tag';

const DELETE_ORG = gql`
  mutation deleteOrg($Id: ID!) {
    deleteOrgSafe(where: { id: $Id }) {
      id
    }
  }
`;

export default DELETE_ORG;
